import getUUId from "../../utils/uuid";
import app from "../../firebaseConfig/firebaseConfig";
import {getDatabase, onValue, ref, set, push, remove, get, child} from "firebase/database";
import {useEffect, useState} from "react";
import {getAuth, onAuthStateChanged} from "firebase/auth";

const db = getDatabase(app);
const auth = getAuth();

class _UserManager {
    constructor() {
        this.userListeners = {};
        this.userDataListeners = {};
        this.unsubscribe = null;
        this.user = {};
        onAuthStateChanged(auth, this.#setUser);
    }

    isAdmin = () => {
        return Boolean(this.user?.customPermission);
    }

    #setUser = (user) => {
        this.user = {noUser: true};
        if (user) {
            this.user = user;
            const dbRef = ref(db);
            get(child(dbRef, `/admins/${user.uid}`)).then((permSnap) => {
                if (permSnap.exists()) {
                    this.user.customPermission = permSnap.val();
                } else {
                    this.user.customPermission = '';
                }

                this.unsubscribe = onValue(ref(db, `users/${user.uid}`), snapshot => {
                    this.userData = snapshot.val();
                    this.callUserDataListeners();
                })
            });
        } else if (this.unsubscribe) {
            this.unsubscribe();
            this.unsubscribe = null;
            this.userData = null;
        }

        this.callUserListeners();
    }

    callUserListeners = () => {
        Object.keys(this.userListeners).forEach(key => {
            this.userListeners[key]({...this.user});
        })
    }

    callUserDataListeners = () => {
        Object.keys(this.userDataListeners).forEach(key => {
            this.userDataListeners[key]({...this.userData});
        })
    }

    #setUserData = (userData) => {
        set(ref(db, `users/${this.user.uid}`), userData);
    }

    setInvoiceData = (invoiceData) => {
        const userData = {...this.userData};
        userData.cart.invoiceData = invoiceData;
        this.#setUserData(userData);
    }

    setDesigns = (designs) => {
        const userData = {...this.userData};
        userData.cart.designs = designs;
        this.#setUserData(userData);
    }

    setSavedAddress = (address, key) => {
        const userData = {...this.userData};
        userData.savedAddresses[key] = address;
        this.#setUserData(userData);
    }

    savePreferredEasyBox = (favLocker) => {
        const userData = {...this.userData};
        userData.favLocker = favLocker;
        this.#setUserData(userData);
    }

    addNewAddressToSavedAdresses = (address) => {
        push(ref(db, `users/${this.user.uid}/savedAddresses`), address);

    }

    deleteAddressFromSavedAdresses = (key) => {
        remove(ref(db, `users/${this.user.uid}/savedAddresses/${key}`));
    }

    getSavedAddresses = () => {
        return this.userData && this.userData.savedAddresses;
    }

    getUserData = () => {
        return this.userData;
    }

    getUser = () => {
        return this.user;
    }

    subscribeUserChange(listener) {
        const uuId = getUUId();
        this.userListeners[uuId] = listener;
        listener(this.user);
        return () => delete this.userListeners[uuId];
    }

    subscribeUserDataChange(listener) {
        const uuId = getUUId();
        this.userDataListeners[uuId] = listener;
        listener(this.userData);
        return () => delete this.userDataListeners[uuId];
    }
}


const UserManager = new _UserManager();
export default UserManager;

export function useUser() {
    const [user, setUser] = useState({});

    useEffect(() => {
        const unsubscribe = UserManager.subscribeUserChange(setUser);
        return () => {
            unsubscribe();
        };
    }, []);

    return user;
}

export function useUserData() {
    const [userData, setUserData] = useState({});

    useEffect(() => {
        const unsubscribe = UserManager.subscribeUserDataChange(setUserData);
        return () => {
            unsubscribe();
        };
    }, []);

    return userData;
}
